import { useSEO } from '@/hooks/useSEO';

export default function Privacy() {
  useSEO({
    title: 'KVKK Aydınlatma Metni | Mayi Mimarlık',
    description: 'Mayi Mimarlık kişisel verilerin korunması ve işlenmesi aydınlatma metni. Diyarbakır.',
    canonical: 'https://mayimimarlik.com/privacy',
    geo: false,
  });

  return (
    <div className="bg-[#fafafa]" style={{ paddingTop: '160px', paddingBottom: '100px', minHeight: '100vh', width: '100%' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', padding: '3rem' }}>
        
        <section style={{ marginBottom: '4rem' }}>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1a1a1a', marginBottom: '2rem', borderBottom: '2px solid #eee', paddingBottom: '1rem' }}>
            KVKK Aydınlatma Metni
          </h1>
          
          <div style={{ color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, color: '#222', marginTop: '2rem', marginBottom: '1rem' }}>
              MAYİ MİMARLIK İNŞAAT GIDA PETROL OTOMOTİV SANAYİ TİCARET LİMİTED ŞİRKETİ
            </h2>
            <p style={{ fontWeight: 600, marginBottom: '2rem' }}>KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ AYDINLATMA METNİ</p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>1. Veri Sorumlusu</h3>
            <p style={{ marginBottom: '1rem' }}>
              6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca, kişisel verileriniz; veri sorumlusu olarak Mayi Mimarlık İnşaat Gıda Petrol Otomotiv Sanayi Ticaret Limited Şirketi (“Şirket”) tarafından aşağıda açıklanan kapsamda işlenebilecektir.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>2. Kişisel Verilerin İşlenme Amacı</h3>
            <p style={{ marginBottom: '0.5rem' }}>Web sitemiz üzerinden paylaştığınız ad, soyad, telefon numarası ve e-posta adresi gibi kişisel verileriniz;</p>
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem', listStyleType: 'disc' }}>
              <li style={{ marginBottom: '0.5rem' }}>Ürünlerimize yönelik teklif taleplerinizin yönetilmesi ve sonuçlandırılması,</li>
              <li style={{ marginBottom: '0.5rem' }}>Bayilik süreçlerinin yürütülmesi ve iletişimin sağlanması,</li>
              <li style={{ marginBottom: '0.5rem' }}>Satış sonrası destek hizmetlerinin sunulması,</li>
              <li style={{ marginBottom: '0.5rem' }}>İlgili mevzuat uyarınca yasal yükümlülüklerimizin yerine getirilmesi amaçlarıyla işlenmektedir.</li>
            </ul>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>3. İşlenen Kişisel Verilerin Aktarımı</h3>
            <p style={{ marginBottom: '1rem' }}>
              Kişisel verileriniz; yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda, iş ortaklarımıza, tedarikçilerimize ve kanunen yetkili kamu kurumlarına ilgili mevzuat çerçevesinde aktarılabilecektir.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>4. Veri Toplamanın Yöntemi ve Hukuki Sebebi</h3>
            <p style={{ marginBottom: '1rem' }}>
              Kişisel verileriniz, web sitemizdeki teklif isteme formu aracılığıyla tamamen veya kısmen otomatik yollarla; "bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması" ve "veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi" hukuki sebeplerine dayanarak toplanmaktadır.
            </p>

            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#333', marginTop: '1.5rem', marginBottom: '0.5rem' }}>5. İlgili Kişinin Hakları</h3>
            <p style={{ marginBottom: '1rem' }}>
              Kanun’un 11. maddesi uyarınca; verilerinizin işlenip işlenmediğini öğrenme, düzeltilmesini veya silinmesini talep etme haklarına sahipsiniz. Başvurularınızı Çeysa Plaza, Mezopotamya, 334. Sk. No:2A, 21070 Kayapınar/Diyarbakır adresine yazılı olarak iletebilirsiniz.
            </p>
          </div>
        </section>

        <section>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1a1a1a', marginBottom: '2rem', borderBottom: '2px solid #eee', paddingBottom: '1rem' }}>
            Çerez (Cookie) Politikası
          </h1>
          
          <div style={{ color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
            <p style={{ marginBottom: '1.5rem' }}>
              <strong>https://www.mayimimarlik.com</strong> olarak, kullanıcı deneyiminizi geliştirmek ve sitemizin verimli çalışmasını sağlamak amacıyla çerezler kullanmaktayız.
            </p>

            <ul style={{ paddingLeft: '1.5rem', marginBottom: '1.5rem', listStyleType: 'disc' }}>
              <li style={{ marginBottom: '0.8rem' }}><strong>Zorunlu Çerezler:</strong> Sitenin düzgün çalışması ve sepet sisteminin işlemesi için gereklidir.</li>
              <li style={{ marginBottom: '0.8rem' }}><strong>Analitik Çerezler:</strong> Ziyaretçi trafiğini anlamak ve site performansını ölçmek için kullanılır.</li>
            </ul>

            <p style={{ marginBottom: '1rem' }}>
              Çerez tercihlerinizi tarayıcı ayarlarınızdan dilediğiniz zaman değiştirebilirsiniz. Sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş sayılırsınız.
            </p>
          </div>
        </section>

      </div>
    </div>
  );
}
